import React from 'react';
import ReactDOM from 'react-dom/client';
import CBOPS from './App.jsx';

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  render() {
    if (this.state.error) {
      return React.createElement('div', { style: { padding: 40, fontFamily: 'monospace', color: '#ef4444', background: '#0a0a0f', minHeight: '100vh' } },
        React.createElement('h2', null, 'CB-OPS Error'),
        React.createElement('pre', { style: { whiteSpace: 'pre-wrap', fontSize: 13, marginTop: 12 } }, String(this.state.error?.stack || this.state.error))
      );
    }
    return this.props.children;
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  React.createElement(ErrorBoundary, null,
    React.createElement(CBOPS)
  )
);
